import { OrderedSet, Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {

} from './actionTypes'
import { TASK_REFRESH, CHAOSHI_REFRESH, ORDER_UPDATED_REFRESH } from '../socket/actionTypes';


const initializeState = Map({
  entries: Map(),
  list: List(),
  total: 0,
  loading: false,
  taskRefreshKey: 'initkey',
  chaoshiRefreshKey: 'initkey',
  orderUpdateRefreshKey: 'initkey',
})



export default createReucer({
  [TASK_REFRESH](state, { payload }) {
    // try {
    //   var audio = new Audio();
    //   audio.src = process.env.PUBLIC_URL + '/new_order.mp3';
    //   audio.play();
    //   audio.addEventListener('ended', () => {
    //     audio.remove();
    //   });
    // } catch (error) {

    // }

    return state.set('taskRefreshKey', Date.now())
  },
  [CHAOSHI_REFRESH](state, { payload }) {
    return state.set('chaoshiRefreshKey', Date.now())
  },
  // [CONV_STATS_FETCHED]: (state, { payload }) => {
  //   const { type, total } = payload
  //   return state.setIn(['convs_stats', type], total)
  // },
  [ORDER_UPDATED_REFRESH]: (state, { payload }) => {
    return state.set('orderUpdateRefreshKey', Date.now())
  },
}, initializeState)
